import SvgCreditcard from '@sats-group/icons/24/creditcard';
import SvgInfo from '@sats-group/ui-lib/react/icons/18/info';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import FlowTerminusLayout from '~/client/components/flow-terminus-layout/flow-terminus-layout';
import type { RenewTerminus as Props } from './renew-terminus.types';

const RenewTerminus: React.FC<Props> = ({ layout, copy, summary }) => (
  <FlowTerminusLayout {...layout}>
    {summary ? (
      <div className="renew-terminus">
        <section className="renew-terminus__about-change">
          <Text theme={Text.themes.headline} size={Text.sizes.large}>
            {copy.aboutChangeTitle}
          </Text>
          <div className="renew-terminus__about-change-item">
            <SvgCreditcard />
            <Text>{summary.sponsorshipText}</Text>
          </div>
          {summary.sponsorshipText ? (
            <div className="renew-terminus__about-change-item">
              <SvgInfo />
              <Text>{summary.validityText}</Text>
            </div>
          ) : null}
        </section>
        <Text size={Text.sizes.large} theme={Text.themes.headline}>
          {copy.detailsTitle}
        </Text>
        <section className="renew-terminus__details-container">
          <div className="renew-terminus__details">
            {summary.renewalDetails.map((detail, index) => (
              <div key={index} className="renew-preview__details-item">
                <Text theme={Text.themes.emphasis} size={Text.sizes.small}>
                  {detail.label}
                </Text>
                <Text size={Text.sizes.small}>{detail.value}</Text>
              </div>
            ))}
          </div>

          <div className="renew-terminus__price-text">
            <Text theme={Text.themes.emphasis} size={Text.sizes.small}>
              {summary.price.title}
            </Text>
          </div>
          <div className="renew-terminus__prices">
            {summary.price.lines.map(entry => (
              <div className="renew-terminus__price" key={entry.text}>
                <Text
                  size={
                    entry.important ? Text.sizes.headline3 : Text.sizes.small
                  }
                  theme={entry.important ? Text.themes.emphasis : undefined}
                >
                  {entry.text}
                </Text>
                {entry.post ? (
                  <Text
                    size={entry.important ? Text.sizes.basic : Text.sizes.small}
                    theme={entry.important ? Text.themes.emphasis : undefined}
                  >
                    {entry.post}
                  </Text>
                ) : null}
              </div>
            ))}
          </div>
        </section>
      </div>
    ) : null}
  </FlowTerminusLayout>
);

export default RenewTerminus;
